import { Alert } from '@mui/material';

import useLayoutEntityFilterContext from '@hooks/useLayoutEntityFilter';
import LayoutEntity from '@models/LayoutEntity';
import LayoutEntityTable, {
  LayoutEntityTableProps,
} from '@modules/layouts/components/LayoutEntityTable';

type LayoutEntityListPageProps<T extends LayoutEntity> = Pick<
  LayoutEntityTableProps<T>,
  'TableRowComponent'
> &
  Partial<Pick<LayoutEntityTableProps<T>, 'columns' | 'displayCount'>> &
  Required<Pick<LayoutEntityTableProps<T>, 'contentType' | 'entityRoute'>> & {
    typeField?: string;
  };

function LayoutEntityListTeaser<T extends LayoutEntity>({
  displayCount = 8,
  columns = [],
  ...rest
}: LayoutEntityListPageProps<T>) {
  const { filteredEntities, loading, error } = useLayoutEntityFilterContext<T>();

  return error ? (
    <Alert severity='error'>{error.message}</Alert>
  ) : (
    <LayoutEntityTable
      {...rest}
      absolutePositioned={false}
      columns={columns}
      disableFilter
      disableNonEssentialCols
      disablePagination
      disableSortable
      displayCount={displayCount}
      idKey='id'
      items={filteredEntities}
      loading={loading}
      tableSearch={true}
    />
  );
}

export default LayoutEntityListTeaser;
